import { defineComponent as _defineComponent } from 'vue'
import { reactive, onMounted } from 'vue'
import { useShowModal, useConfirmWithPromise } from '@/composables/useModalOpener'
import useGlobal from '@/composables/useGlobal'
import { $vfm } from 'vue-final-modal'

const PENDING_EVENT_KEY = 'pendingEventRegistration'


export default /*@__PURE__*/_defineComponent({
  __name: 'RequestFormWrapper',
  props: {
  periods: {
    type: Array,
  },
  eventId: {
    type: Number,
  },
  price: {
    type: Number,
  },
  videoPrice: {
    type: Number,
  },
  actualPrice: {
    type: Number,
  },
  registrationCompleted: {
    type: Boolean,
  },
  pastEvent: {
    type: Boolean,
  },
  canBuyVideo: {
    type: Boolean,
  },
  userHasEvent: {
    type: Boolean,
  },
  cartType: {
    type: String,
  },
  registrationTime: {
    type: String,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const page403Url = window.page403Url
const userIsAuthenticated = window.isAuthenticated

const props = __props

const { $t } = useGlobal()
const formdata = reactive({
  period: {},
})

const selectDate = (period: any) => {
  formdata.period = period
}

const openEventModal = (eventId: number, periodId: number) => {
  $vfm.show({
    component: 'UiModalContainer',
  }, {
    classes: 'modal--size_lg',
    component: 'Events/RequestFormEvent',
    periodId: periodId,
    eventId: eventId,
  })
}

const confirmRegistration = async () => {
  if (!userIsAuthenticated) {
    const message = {
      title: $t('Увага!'),
      text: $t('Необхідно авторизуватися для створення заявки. Продовжити?'),
    }
    await useConfirmWithPromise(message)
    sessionStorage.setItem(PENDING_EVENT_KEY, JSON.stringify({
      eventId: props.eventId,
      periodId: formdata.period.id || null,
      eventUrl: window.location.pathname,
    }))
    window.location.href = page403Url
  } else {
    if (formdata.period.id || props.canBuyVideo) {
      openEventModal(props.eventId, formdata.period.id)
    } else {
      const message = {
        title: $t('Спочатку оберіть дату на яку бажаете записатись'),
      }

      useShowModal(message)
    }
  }
}

onMounted(() => {
  // Показати повідомлення про успішну реєстрацію якщо є ?registered=1 в URL
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.get('registered') === '1') {
    const message = {
      title: $t('Вітаємо!'),
      text: $t('Вас успішно зареєстровано на захід'),
    }
    useShowModal(message)
    // Прибрати параметр з URL без перезавантаження сторінки
    const url = new URL(window.location.href)
    url.searchParams.delete('registered')
    window.history.replaceState({}, '', url.toString())
  }

  const pending = sessionStorage.getItem(PENDING_EVENT_KEY)
  if (!pending || !userIsAuthenticated) return

  try {
    const { eventId, periodId } = JSON.parse(pending)
    if (eventId !== props.eventId) return

    sessionStorage.removeItem(PENDING_EVENT_KEY)

    if (periodId) {
      const period = (props.periods as any[])?.find(p => p.id === periodId)
      if (period) formdata.period = period
    }

    openEventModal(eventId, periodId)
  } catch (e) {
    sessionStorage.removeItem(PENDING_EVENT_KEY)
  }
})

const __returned__ = { PENDING_EVENT_KEY, page403Url, userIsAuthenticated, props, $t, formdata, selectDate, openEventModal, confirmRegistration, reactive, onMounted, get useShowModal() { return useShowModal }, get useConfirmWithPromise() { return useConfirmWithPromise }, get useGlobal() { return useGlobal }, get $vfm() { return $vfm } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})